import React from "react";
import "./Settings.css";
import Grid from '@mui/material/Grid2';
import { TextField, InputAdornment, Box, Button } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { GlobalContext } from "../../Context/GlobalContext";
import useAxios from '../../Hooks/useAxios';
import ReportsGantt from "../../Components/ReportsGantt/ReportsGantt";
import ReportsMetricCards from "../../Components/ReportsMetricCards/ReportsMetricCards";
import { useAuth } from 'react-oidc-context';
import { AxiosService } from '../../Services/AxiosService';

/**
 * A container component for displaying the reports dashboard.
 * Focuses on rendering the top metrics and the main Gantt chart.
 *
 * @component
 * @returns {React.Element} The rendered Settings component.
 */

function Settings() {
  const ref = React.useRef(null);
 // const { setCurrentTab, currentTab } = React.useContext(GlobalContext);
 // const { data, isLoading, error } = useAxios("allSubprocessesDetails");
 // const [searchTerm, setSearchTerm] = React.useState("");

  const [frecuency, setFrecuency] = React.useState("");
  const [frecuencyError, setFrecuencyError] = React.useState(false);
  const auth = useAuth();

  const {
      modalOpen,
      setModalOpen,
      modalData,
      setAlertOpen,
      setAlertType,
      setAlertTitle,
      setAlertMessage,
      userProperties,
      setAlertBarSeverity,
      setAlertBarMessage,
      setAlertBarOpen
    } = React.useContext(GlobalContext);

    const userId = userProperties?.id;




  /**
   * CSS styles for the container element.
   * Modificado para permitir crecimiento vertical y scroll interno si es necesario.
   * * @type {Object}
   * @property {string} minHeight - The minimum height to fill the available viewport.
   * @property {string} height - Set to auto to allow content-driven growth.
   * @property {string} bgcolor - The background color of the container.
   * @property {number} flexGrow - The flex-grow value for the container.
   * @property {string} overflowY - Controls the vertical scroll behavior.
   * @property {string} paddingBottom - Provides extra space at the end of the scroll.
   */
  const ContainerStyle = {
    minHeight: "calc(100vh - 110px)",
    height: "auto",
    bgcolor: "transparent",
    flexGrow: 1,
    overflowY: "auto",
    paddingBottom: "20px"
  };

  /**
   * Handles the search input change.
   * @param {React.ChangeEvent<HTMLInputElement>} event - The input change event.
   */
  // const handleSearchChange = (event) => {
  //   setSearchTerm(event.target.value.toLowerCase());
  // };

  const handleAccept = async () => {

  if (isAValidValue(frecuency))
  {


     const requestBody0 =  {

         targetEmployee: {

             notificationFrecuency: frecuency
             }

         }
          console.log("requestBody: ", requestBody0);

     AxiosService.patch_frecuency(auth.user?.access_token, requestBody0, userId)
     .then((response) => {
       //console.log("response: ", response);
       //setLoadingPOST(false);
       setAlertBarSeverity("success");
       setAlertBarMessage(response.data.message);
       setAlertBarOpen(true);
       //setNewTaskOpen(false);
       //navigate("/#");
     })

        .catch((err) => {
          setAlertBarSeverity("error");
          setAlertBarMessage(`${err.message} (${err.response.statusText}): ${err.response.data.error}`);
          setAlertBarOpen(true);
        })

     }


  }

  const isAValidValue = (value) => {
    let bResult = false;
    const numberValue = Number(value);
    const isValid =
    Number.isInteger(numberValue) &&
    numberValue >= 0 &&
    numberValue <= 30;

    if (isValid)
        bResult = true;
    return bResult;

  }

  return (
    <div ref={ref} className="container_body" style={ContainerStyle}>
    <div>
    <br></br>
    <h3>Input reminder frecuency</h3>
      <TextField
        id="frecuencySettings"
        error={frecuencyError}
        value={frecuency}
        label="number of days between reminder messages"
        onChange={(event) => {

        const value = event.target.value;

               setFrecuency(value);

               // const numberValue = Number(value);
//
               // const isValid =
               //     Number.isInteger(numberValue) &&
               //     numberValue >= 0 &&
               //     numberValue <= 30;

                   if (!isAValidValue(value)) {

                        setFrecuencyError(true);

                        return;
                   }
                   else
                   setFrecuencyError(false);



        }}
        helperText={frecuencyError && "Invalid format. Expected numeric value (0 - 30)"}
        inputProps={{ type: "text" , pattern: "^(30|[0-9]|[1-2][0-9])$"}}
        sx={{ width: 360 , marginTop: "10px"}}
      />

      </div>

      <Button
          sx={{ mt: 2 }}
          variant="contained"
           onClick={handleAccept}

        >
          Accept
        </Button>




    </div>
  );
}

export default Settings;